module.exports = __webpack_public_path__ + "28e12c5e163c84d128e6cea5df1ebc4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/9.jpg
// module id = 1368
// module chunks = 47